var map = {
	"./knife.webp": "4720",
	"./machinegun.webp": "4db4",
	"./pistol.webp": "4073",
	"./rifle.webp": "c74f",
	"./shotgun.webp": "fd66",
	"./smg.webp": "e5ef",
	"./sniperrifle.webp": "a60b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "160a";